import { Component, OnInit } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ResetPasswordService } from '../../../../core/services/reset-password.service';
import { UiHelperService } from '../../../../services/ui-helper.service';
import { NotificationService } from '../../../../services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-step-verificacion',
  templateUrl: './step-verificacion.component.html',
  styleUrls: ['./step-verificacion.component.css'],
  standalone: false
})
export class StepVerificacionComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  correoOfuscado = '';
  datosVerificacion: any = null;

  constructor(
    private resetPassword: ResetPasswordService,
    private uiHelper: UiHelperService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    const raw = this.resetPassword.getStorage('datosVerificacion');
    if (raw) {
      try {
        this.datosVerificacion = JSON.parse(raw);
        this.correoOfuscado = this.ofuscarCorreo(this.datosVerificacion.correoElectronico || '');
      } catch (_) {}
    }
  }

  ofuscarCorreo(correo: string): string {
    if (!correo) return '****';
    const [u, d] = correo.split('@');
    if (!d) return '****';
    const uVis = u.length <= 3 ? u.substring(0, 1) + '*'.repeat(u.length - 1) : u.substring(0, 3) + '*'.repeat(u.length - 3);
    const dVis = d.length > 2 ? d.substring(0, 2) + '*'.repeat(d.length - 2) : '**';
    return uVis + '@' + dVis;
  }

  enviarOTP(): void {
    if (!this.datosVerificacion) {
      Swal.fire({ title: 'Error', text: 'Faltan datos de verificación.', icon: 'error', ...this.notification.getSwalBaseConfig() });
      return;
    }
    const request = {
      email: this.datosVerificacion.correoElectronico,
      razonSocial: (this.datosVerificacion.nombres || '') + ' ' + (this.datosVerificacion.apellidos || '')
    };
    this.uiHelper.showSpinner('Enviando código...', 'admin');
    const baseConfig = this.notification.getSwalBaseConfig();
    this.resetPassword.enviarOtp(request).pipe(
      finalize(() => this.uiHelper.hideSpinner())
    ).subscribe({
      next: (res) => {
        if (res?.successful === true && res?.transactionId) {
          this.resetPassword.setStorage('transactionId', res.transactionId);
          this.next.emit();
        } else {
          Swal.fire({ title: 'Error', text: 'No se pudo enviar el código.', icon: 'error', ...baseConfig });
        }
      },
      error: (err) => {
        const msg = (err && (err as any).message) || err?.error?.mensaje || err?.error?.message || 'No se pudo enviar el código.';
        Swal.fire({
          title: 'Error',
          text: msg,
          icon: 'error',
          ...this.notification.getSwalBaseConfigReloadAfterClose()
        });
      }
    });
  }
}
